module.exports = __webpack_public_path__ + "img/Service_content_2.03e490c5.png";